import { fmtRoDate } from "../../lib/dateFmt";

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${fmtRoDate(iso.slice(0, 10))} ${d.toLocaleTimeString("ro-RO", { hour: "2-digit", minute: "2-digit" })}`;
  } catch { return iso; }
};
